import * as go from 'gojs';
import { getImageFreeFallScreenSF } from 'unitData/FreeFallScreenSF/freeFallScreenSFData';
import {
  getImageBinding,
  getIOPort,
  getDeckPortPanel,
  makeNode,
} from '../../utils';

const alignScreenPort = (
  mirrored: boolean,
  portIndex: number,
  decks?: number,
) => {
  const x = mirrored ? 0 : 1;

  if (decks === 3) {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 3 / 6);
      case 1:
        return new go.Spot(x, 4 / 6);
      case 2:
        return new go.Spot(x, 5 / 6);
      case 3:
        return new go.Spot(0.5, 1);
    }
  } else if (decks === 4) {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 2 / 6);
      case 1:
        return new go.Spot(x, 3 / 6);
      case 2:
        return new go.Spot(x, 4 / 6);
      case 3:
        return new go.Spot(x, 5 / 6);
      case 4:
        return new go.Spot(0.5, 1);
    }
  }
};

const FreeFallScreenSFTemplate = makeNode(
  getImageBinding('nbrOfDecks', getImageFreeFallScreenSF),
  [
    getIOPort(go.Spot.Top, 'input'),
    getDeckPortPanel(0, alignScreenPort),
    getDeckPortPanel(1, alignScreenPort),
    getDeckPortPanel(2, alignScreenPort),
    getDeckPortPanel(3, alignScreenPort, (node) => node.nbrOfDecks >= 3),
    getDeckPortPanel(4, alignScreenPort, (node) => node.nbrOfDecks >= 4),
    getDeckPortPanel(5, alignScreenPort, (node) => node.nbrOfDecks >= 5),
  ],
);

export default FreeFallScreenSFTemplate;
